/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFlaskFilled: {
  name: 'flask-filled';
  data: string;
} = {
  name: 'flask-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.643 2.069C7.291 2.193 7 2.614 7 3c0 .242.119.521.299.701.247.247.442.299 1.128.299H9v5.634l-2.664 3.913c-1.465 2.152-2.716 4.016-2.779 4.141-.378.744-.394 1.75-.042 2.527.413.911 1.231 1.558 2.181 1.723.526.092 12.067.094 12.609.002 1.114-.188 2.09-1.119 2.361-2.251.079-.331.088-1.03.017-1.329-.133-.556-.236-.721-2.987-4.765L15 9.633V4h.573c.686 0 .881-.052 1.128-.299a.984.984 0 0 0 0-1.402c-.317-.317-.035-.299-4.718-.296-3.663.003-4.184.011-4.34.066"/></svg>`
};
